// extracted by mini-css-extract-plugin
export var buttonContainer = "_8u-1";
export var fontSizeSelect = "_8u-3";
export var formatSelect = "_8u-2";
export var formats = "_8u-4";
export var hidden = "_8u-5";
export var icon = "_8u-6";
export var select = "_8u-0";